/* eslint-disable no-magic-numbers */
import React, { useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";
import { yieldToMain } from "../../../utils/helpers/yield-to-main";
import ErrorHandler from "../../shared/with-error-handler";

const CarDetailNavigationMenuRevampContent = ({
    menuItems = []

}) => {
    const activeMenu = useRef();
    const menuRef = useRef();
    const [width, setWidth] = useState("inherit");

    const onClickNavItem = async (e, item, index) => {
        const currentMenuRef = menuRef.current;
        const leftOffset = e.target.offsetLeft - 20;
        const target = item.entry.target;

        const activeMenuIndex = menuItems?.reduce((pv, cv, idx) => cv.inView ? idx : pv, 0);
        const isUpwardClick = index < activeMenuIndex ? true : false;
        const downwardOffset = 180;
        const offset = isUpwardClick ? 180 : downwardOffset;
        await yieldToMain();
        trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS_NAVIGATION_ITEMS_CLICKED, {
            eventLabel: item.gtmLabel
        });
        window.setTimeout(() => {
            window.setTimeout(() => {
                currentMenuRef.scrollTo(leftOffset, 0);
                window.scrollBy({ left: 0, top: target.getBoundingClientRect().bottom - target.offsetHeight - offset, behavior: "smooth" });
            }, 0);
        }, 180);
    };

    useEffect(() => {
        if (width === "inherit") {
            const currentMenuRef = menuRef.current;
            const finalWidth = currentMenuRef.scrollWidth + window.innerWidth;
            setWidth(finalWidth);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        const currentMenuRef = menuRef.current;
        if (activeMenu && activeMenu.current) {
            const menuItem = activeMenu.current;
            window.setTimeout(() => {
                currentMenuRef.scrollTo(menuItem.offsetLeft, 0);
            }, 0);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [JSON.stringify(menuItems)]);

    // const startIndex = menuItems.length + 1;

    return (
        <React.Fragment>
            <div ref={menuRef} className={"container"}>
                <div styleName={`styles.navigationWrap`}>
                    <ul styleName={"styles.navigation"} >
                        { menuItems?.map((item, index) => (
                            item.isVisible &&  <li
                                styleName={item.inView === true ? "styles.active" : undefined}
                                key={index}
                                onClick={(e) => onClickNavItem(e, item, index)}
                                ref={item?.inView === true ? activeMenu : undefined}
                            >
                                {item?.label}
                            </li>
                        )) }
                    </ul>
                </div>
            </div>
        </React.Fragment>
    );
};

CarDetailNavigationMenuRevampContent.propTypes = {
    menuItems: PropTypes.array
};

const CarDetailNavigationMenuRevamp = (props) => (
    <ErrorHandler>
        <CarDetailNavigationMenuRevampContent {...props} />
    </ErrorHandler>
);

CarDetailNavigationMenuRevamp.propTypes = {
    menuItems: PropTypes.array
};

export default CarDetailNavigationMenuRevamp;
